import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeoCoordinate } from '../types';

interface MapState {
  selectedLocation: GeoCoordinate | null;
  navigateToLocation: boolean;
}

const initialState: MapState = {
  selectedLocation: null,
  navigateToLocation: false,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapLocation: (state, action: PayloadAction<GeoCoordinate>) => {
      state.selectedLocation = action.payload;
      state.navigateToLocation = true;
    },
    clearNavigateFlag: (state) => {
      state.navigateToLocation = false;
    },
    clearMapLocation: (state) => {
      state.selectedLocation = null;
      state.navigateToLocation = false;
    },
  },
});

export const { setMapLocation, clearNavigateFlag, clearMapLocation } = mapSlice.actions;
export default mapSlice.reducer;